<div *ngIf="isPageLoading" class="host-block">
  <div class="spinner-border text-secondary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>